// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__4rr5F","title":"BackImages_title__26_kx","images":"BackImages_images__3BMiV"};